var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5 text-center"},[_c('div',[_c('p',[_vm._v("© "+_vm._s(_vm.currentYear())+" "),_c('a',{attrs:{"href":"https://resourcebase.com/","target":"_blank"}},[_vm._v("Resourcebase")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }